<template>
	<div class="Menu">
		<div class="menu-nav">
			<van-nav-bar :fixed="true">
				<template #left>
					<div class="left-text">
						<div class="logo"><img class="auto-img" src="../assets/images/coffee_icon.jpg" alt=""></div>
						<div class="logo-title">Luckin Coffee</div>
					</div>
				</template>
			</van-nav-bar>
		</div>
		
		<!-- 轮播图 -->
		<div class="banner-box">
			<div class="box-box">
				<van-swipe class="my-swipe" :autoplay="3000" :show-indicators="false">
					<!-- van-swipe-item v-for="(item,index) in bannerData" :key="index"><img class="auto-img" :src="item.bannerImg" alt=""></van-swipe-item> -->
					<van-swipe-item><img class="auto-img" src="../assets/images/swipe_img_1.png" alt=""></van-swipe-item>
					<van-swipe-item><img class="auto-img" src="../assets/images/swipe_img_2.png" alt=""></van-swipe-item>
					<van-swipe-item><img class="auto-img" src="../assets/images/swipe_img_3.png" alt=""></van-swipe-item>
					<van-swipe-item><img class="auto-img" src="../assets/images/swipe_img_4.png" alt=""></van-swipe-item>
					<van-swipe-item><img class="auto-img" src="../assets/images/swipe_img_5.png" alt=""></van-swipe-item>
					<van-swipe-item><img class="auto-img" src="../assets/images/swipe_img_6.png" alt=""></van-swipe-item>
					<van-swipe-item><img class="auto-img" src="../assets/images/swipe_img_7.png" alt=""></van-swipe-item>
					<van-swipe-item><img class="auto-img" src="../assets/images/swipe_img_8.png" alt=""></van-swipe-item>
				</van-swipe>
			</div>
		</div>

		<!-- 侧边导航栏 -->
		<div class="slider clearfix">
			<van-sidebar  v-model="activeKey" class="fl">
				<van-sidebar-item style="color: #000080;" v-for="(item,index) in productType" :key="index" :title="item.typeDesc" @click="getprodcutByType(item)" />
			</van-sidebar>
			
			<div class="item-box fr clearfix">
				<div class="productType fl" v-for="(item,index) in products" :key="index" @click="viewProductInfo(item.pid)">
					<div class="product-img">
						<img class="auto-img" :src="item.smallImg" alt="">
					</div>
					<div class="decription clearfix">
						<div class="pname one-text">{{item.name}}</div>
						<div class="type one-text">{{item.type}}</div>
						<div class="price one-text">{{item.price}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import '../assets/less/menu.less'
	export default {
		name: 'Menu',
		data() {
			return {
				activeKey: 0,
				productType: [],
				products: []
			};
		},

		created() {
			this.getprodcutType();
		},

		methods: {
			//获取商品类型数据
			getprodcutType() {

				this.$toast.loading({
						message: '加载中...',
						forbidClick: true,
						duration: 0,
						loadingType: 'spinner'
					}),
					this.axios({
						method: 'GET',
						url: '/type',
						//如果get请求，参数需要放在params,如果是post请求，参数需要放在data
						params: {
							appkey: this.appkey
						}

					}).then(result => {
						this.$toast.clear();
							if(result.data.code === 400){
							result.data.result.unshift({
								type: 'isHot',
								typeDesc: '推荐'
							})
							
							this.productType = result.data.result;
							this.getprodcutByType(this.productType[0])
						}
					}).catch(err => {
						this.$toast.clear();
					})
			},

			//根据商品类型获取商品数据	
			getprodcutByType(item) {
				// 品数据，不发起请求
				let data = sessionStorage.getItem(item.type);
				
				if(data){
					this.products = JSON.parse(data);
					return;
				}
				
				let params = {
					key: 'type',
					value: item.type,
					appkey: this.appkey
				};
				
				
				if (item.type == 'isHot') {
					params.key = 'isHot';
					params.value = 1;
				}
				
					this.$toast.loading({
					  message: '加载中...',
					  forbidClick: true,
					  duration: 0,
					  loadingType: 'spinner'
					})
					
					
					this.axios({
						method: 'GET',
						url: '/typeProducts',
						//如果get请求，参数需要放在params,如果是post请求，参数需要放在data
						params
					}).then(result => {
						this.$toast.clear();
						if (result.data.code == 500) {
							this.products = result.data.result
							
							//将商品数据缓存
							sessionStorage.setItem(item.type,JSON.stringify(this.products));
							
						}
					}).catch(err => {
						this.$toast.clear();
					})
			},
			
			//查看商品详情
			viewProductInfo(pid){
				this.$router.push({name: 'Detail', query: {pid}});
			},
		}
	}
</script>

<style lang="less" scoped>
	.my-swipe .van-swipe-item {
		color: #fff;
		font-size: 20px;
		line-height: 150px;
		text-align: center;
		background-color: #39a9ed;
	}
</style>
